import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ProgressSpinner } from "primereact/progressspinner";
import { RootState } from "app/store";
import { CONTACT_PROFILE_LOOKUP } from "app/redux";
import { getObjectFromSessionStore, setObjectInSessionStore } from "app/utils/sessionStore";
import { CommentProvider } from "app/uicomponents/macrocomponents/Comments/CommentContext";
import CommentLayout from "app/uicomponents/macrocomponents/Comments/CommentLayout";
import { useIPContext } from "app/pages/InteractiveProposal/InteractiveProposalProvider";
import PageHeader from "app/pages/InteractiveProposal/InteractiveProposalHeader";
import InteractiveProposalSidebar from "app/pages/InteractiveProposal/InteractiveProposalSidebar";

const InteractiveReviewCenterLayout = () => {
  const lookUpResponse = useSelector((state: RootState) => state?.contactProfileLookup);
  const { isLoading } = lookUpResponse;
  const dispatch = useDispatch();

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isCommentMode, setIsCommentMode] = useState(false);
  const mainContentRef = useRef<HTMLDivElement>(null);

  const { summaryData: proposalSummary, summaryError, summaryLoading } = useIPContext();
  const getlookUpResponse = getObjectFromSessionStore("lookUpResponse");
  const location = useLocation();
  const pathName = location.pathname.split("/")[2];

  // Scroll to top on route change
  useEffect(() => {
    if (mainContentRef.current) {
      mainContentRef.current.scrollTop = 0;
    }
  }, [pathName]);

  // Ensure lookup data is available for header branding
  useEffect(() => {
    if (!getlookUpResponse?.menu) {
      dispatch({
        type: CONTACT_PROFILE_LOOKUP,
        payload: { address: "lookupAfter" },
      });
    }
  }, []);

  useEffect(() => {
    if (lookUpResponse?.data?.menu) {
      setObjectInSessionStore("lookUpResponse", lookUpResponse?.data);
    }
  }, [lookUpResponse]);

  const loadingPage = isLoading || summaryLoading;

  const mainContent = () => {
    if (loadingPage) {
      return (
        <div className="flex justify-center items-center h-full">
          <ProgressSpinner />
        </div>
      );
    }
    return <Outlet />;
  };

  return (
    <CommentProvider commentModeActive={isCommentMode} setIsCommentMode={setIsCommentMode}>
      <div className={`flex h-screen ${isCommentMode ? "comment-mode" : ""}`}>
        <PageHeader
          title={proposalSummary?.employerName}
          subtitle={`${proposalSummary?.primaryContact?.firstName ?? ""} ${
            proposalSummary?.primaryContact?.lastName ?? ""
          }`}
          proposalNo={proposalSummary?.proposalNo}
          proposalType={proposalSummary?.proposalType}
          error={summaryError}
          loadingPage={loadingPage}
          isCollapsed={isCollapsed}
          animationData={null}
          setIsHovered={() => {}}
          lottieRef={{ current: null }}
          setIsCommentMode={setIsCommentMode}
          isCommentMode={isCommentMode}
        />
        <CommentLayout
          commentLayoutId={`interactive-review-center-${pathName}`}
          className="flex flex-1 overflow-x-hidden"
        >
          <InteractiveProposalSidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
          <div
            ref={mainContentRef}
            className="flex-1 overflow-auto overflow-x-hidden h-[calc(100vh-70px)] mt-auto py-4 pl-6 pr-4 scrollbar-hide"
          >
            {mainContent()}
          </div>
        </CommentLayout>
      </div>
    </CommentProvider>
  );
};

export default InteractiveReviewCenterLayout;
